import ContactosService from "common/services/ContactosService"
import FormCamposPersonalizados from "features/Contactos/forms/Personalizados"
import useContactoDetails from "features/Contactos/hooks/useContactoDetails"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const Personalizados = ({ id, getContactoById }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { updateData, data } = useContactoDetails({
    id,
    fetch: ContactosService.getContactoCamposPersonalizados,
    update: ContactosService.updateContactoCamposPersonalizados,
    onUpdateSuccess: getContactoById,
  })

  const [etiquetas, setEtiquetas] = useState([])

  useEffect(() => {
    ContactosService.getContactoEtiquetas().then((res) =>
      setEtiquetas(res.data.items)
    )
  }, [])

  return (
    <div className='px-3 contactos-personalizados'>
      <FormCamposPersonalizados
        // @ts-expect-error TS(2322): Type '{ data: never[]; updateData: (payload: $TSFixMe) ...
        data={data}
        updateData={updateData}
        etiquetas={etiquetas}
        t={t}
      />
    </div>
  )
}

export default Personalizados
